{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Trasferisci a un operatore",
    "MESSAGE": "Trasferiscimi a un operatore"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Scarica",
      "UPLOADING": "Caricamento..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Invia"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Invia di nuovo il messaggio",
      "ERROR_MESSAGE": "Impossibile inviare, riprova"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Valuta la qualità di questa risposta"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Per favore, attendi che si unisca un agente"
  },
  "ROBOT_CHECK": {
    "TITLE": "Controllo di sicurezza rapido",
    "DESCRIPTION": "Per favore, completa il controllo qui sotto.",
    "VERIFYING": "Verifica in corso…",
    "ERROR": "Non ha funzionato. Riprova.",
    "RETRY": "Riprova"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Siamo online",
    "OFFLINE": "Siamo offline in questo momento",
    "ONLINE_WITH_BOT": "Il team e il nostro assistente IA sono online",
    "OFFLINE_WITH_BOT": "Il nostro assistente IA è qui per aiutarti",
    "BOT_ONLY_REPLY": "Risponde immediatamente"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "In genere risponde in pochi minuti",
    "IN_A_FEW_HOURS": "In genere risponde in poche ore",
    "IN_A_DAY": "In genere risponde in un giorno",
    "BACK_IN": "Torneremo online"
  },
  "DAY_NAMES": {
    "SUNDAY": "Domenica",
    "MONDAY": "Lunedì",
    "TUESDAY": "Martedì",
    "WEDNESDAY": "Mercoledì",
    "THURSDAY": "Giovedì",
    "FRIDAY": "Venerdì",
    "SATURDAY": "Sabato"
  },
  "START_CONVERSATION": "Avvia conversazione",
  "END_CONVERSATION": "Termina conversazione",
  "CONTINUE_CONVERSATION": "Continua conversazione",
  "YOU": "Tu",
  "START_NEW_CONVERSATION": "Avvia una nuova conversazione",
  "RESOLVE_LATER": "Risolveremo questo argomento via email/telefono. Ora vorrei chiedere qualcos'altro.",
  "VIEW_UNREAD_MESSAGES": "Hai messaggi non letti",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Vedi i nuovi messaggi",
    "CLOSE_MESSAGES_BUTTON": "Chiudi",
    "COMPANY_FROM": "da",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Chatta con noi"
  },
  "POWERED_BY": "Offerto da {brandName}",
  "EMAIL_PLACEHOLDER": "Inserisci la tua email",
  "CHAT_PLACEHOLDER": "Scrivi il tuo messaggio",
  "TODAY": "Oggi",
  "YESTERDAY": "Ieri",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Nome completo",
        "PLACEHOLDER": "Per favore inserisci il tuo nome completo",
        "REQUIRED_ERROR": "Il nome completo è obbligatorio"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Indirizzo email",
        "PLACEHOLDER": "Inserisci il tuo indirizzo email",
        "REQUIRED_ERROR": "L'indirizzo email è obbligatorio",
        "VALID_ERROR": "Inserisci un indirizzo email valido"
      },
      "PHONE_NUMBER": {
        "LABEL": "Numero di telefono",
        "PLACEHOLDER": "Inserisci il tuo numero di telefono",
        "REQUIRED_ERROR": "Il numero di telefono è obbligatorio",
        "DIAL_CODE_VALID_ERROR": "Seleziona un prefisso internazionale",
        "VALID_ERROR": "Inserisci un numero di telefono valido",
        "DROPDOWN_EMPTY": "Nessun risultato trovato",
        "DROPDOWN_SEARCH": "Cerca paese"
      },
      "MESSAGE": {
        "LABEL": "Messaggio",
        "PLACEHOLDER": "Per favore inserisci il tuo messaggio",
        "ERROR": "Messaggio troppo corto"
      }
    },
    "CAMPAIGN_HEADER": "Per favore inserisci il tuo nome ed email prima di iniziare la conversazione",
    "IS_REQUIRED": "è obbligatorio",
    "REQUIRED": "Obbligatorio",
    "REGEX_ERROR": "Inserisci un valore valido"
  },
  "FILE_SIZE_LIMIT": "Il file supera il limite di {MAXIMUM_FILE_UPLOAD_SIZE} per poter essere allegato",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Campo non valido"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Cerca emoji",
    "NOT_FOUND": "Nessuna emoji corrisponde alla ricerca",
    "ARIA_LABEL": "Selettore emoji"
  },
  "CSAT": {
    "TITLE": "Valuta la conversazione",
    "SUBMITTED_TITLE": "Grazie per aver inviato la valutazione",
    "PLACEHOLDER": "Raccontaci di più..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Richiedi la trascrizione della conversazione",
    "SEND_EMAIL_SUCCESS": "La trascrizione della chat è stata inviata con successo",
    "SEND_EMAIL_ERROR": "Si è verificato un errore, riprova"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Articoli popolari",
    "VIEW_ALL_ARTICLES": "Vedi tutti gli articoli",
    "IFRAME_LOAD_ERROR": "Si è verificato un errore durante il caricamento dell'articolo. Aggiorna la pagina e riprova."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Apri",
      "BUY": "Acquista"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Messaggio immagine"
    },
    "audio": {
      "CONTENT": "Messaggio audio"
    },
    "video": {
      "CONTENT": "Messaggio video"
    },
    "file": {
      "CONTENT": "File allegato"
    },
    "location": {
      "CONTENT": "Posizione"
    },
    "fallback": {
      "CONTENT": "ha condiviso un url"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "In risposta a:"
  }
}
